import { getApi } from "../../helpers/auth_helpers";
import { categoryParams } from "../../pages/products/categoryFilter";

export type PickerProduct = Record<string, any> & { productUniqueId: string; canAdd?: boolean; reason?: string; status?: string; inStock?: boolean };
export type ProductPage = { products: PickerProduct[]; total: number };
export type PickerQuery = { filters: Record<string, any>; sort: string; exact: string; revision?: number };
export type ProductPageLoader = (query: PickerQuery, page: number, limit: number) => Promise<ProductPage>;
export const PAGE_SIZE = 20;
/** Only locally authored, user-facing loader messages may cross this boundary. */
export class ProductPageError extends Error {}
export const initialProductFilters = () => ({ inStock: { label: "In stock", value: "true" }, includeAiSuggestions: true });

/** Same Product API/filter contract as getProducts Redux. URLSearchParams preserves literal IDs/search text. */
export async function fetchPickerProducts(query: PickerQuery, page: number, limit: number): Promise<ProductPage> {
  const f = query.filters;
  const [sortBy, orderBy] = query.sort.split(":");
  const params = new URLSearchParams({ offset: String(page), limit: String(limit), sortBy, orderBy });
  const fields: Record<string, any> = {
    name: f.productName, productId: f.ProductId, xuid: f.xuid, tags: f.tags, q: f.q, color: f.color,
    artFormId: f.artform?.value, typeId: f.type?.value, ...categoryParams(f.category),
    subcategoryId: f.category?.byName ? undefined : f.subCategory?.value, weavetypeId: f.weaveType?.value,
    createdAfter: f.createdAfter, createdBefore: f.createdBefore,
    inStock: f.inStock?.value, includeAiSuggestions: f.includeAiSuggestions !== false,
    minSellPrice: f.price?.minSellPrice, maxSellPrice: f.price?.maxSellPrice,
    minSellPriceInclusive: f.price?.minSellPriceInclusive, maxSellPriceInclusive: f.price?.maxSellPriceInclusive,
    priceStatus: f.price?.priceStatus, includeUnpriced: f.price?.includeUnpriced,
  };
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") params.set(key, String(value));
  });
  const response: any = await getApi(`${process.env.REACT_APP_SERVERURL || ""}/product/products?${params}`);
  if (response?.success === false || !Array.isArray(response?.data?.docs)) throw new Error("Inventory unavailable");
  const payload = response.data;
  return { products: payload.docs, total: Number(payload.pagination?.total ?? payload.length ?? payload.totalCount ?? payload.total ?? 0) };
}

export function uniqueProducts(products: PickerProduct[]): PickerProduct[] {
  const byId = new Map<string, PickerProduct>();
  products.forEach((product) => {
    // Missing canonical identity is never replaced with a database ID.
    if (typeof product.productUniqueId === "string" && product.productUniqueId.trim()) byId.set(product.productUniqueId, product);
  });
  return Array.from(byId.values());
}
